import { useState } from "react";
import { EventSelectorBar } from "../components/organisms/EventSelectorBar.jsx";
import { QrScannerPanel } from "../components/organisms/QrScannerPanel.jsx";
import { VisitorLookupSection } from "../components/organisms/VisitorLookupSection.jsx";
import { PageHeader } from "../components/organisms/PageHeader.jsx";
import { useEvent } from "../contexts/EventContext";
import { decodeBase64 } from "../lib/decodeBase64.js";

export const ScanPage = () => {
  const [encodedSynergyId, setEncodedSynergyId] = useState("");
  const [qrEventKey, setQrEventKey] = useState("");

  const { selectedEvent } = useEvent();

  // ✅ ここから必要な値だけ取る
  const eventDate = selectedEvent?.date ?? "";
  const eventTableKey = selectedEvent?.tableKey ?? "";

  const [parseError, setParseError] = useState("");

  const [processing, setProcessing] = useState(false);

  const handleDetected = (raw) => {
    try {
      setParseError("");
      const parsed = JSON.parse(raw);
      const decodedEventKey = decodeBase64(parsed.event_key);
      const qrId = parsed.id;

      if (!qrId) {
        setEncodedSynergyId("");
        return;
      }

      // QRのイベントを保持
      setQrEventKey(decodedEventKey);
      // SynergyIDをセット
      setEncodedSynergyId(qrId);
    }
    catch (e) {
      console.error("QR parse error", e);
      setParseError(
        "無効なQRコードです"
      );
      setEncodedSynergyId("");
      setQrEventKey("");
    }
  };

  // QRに埋め込まれたイベント優先で検索
  const lookupTableKey = qrEventKey || eventTableKey;

  return (
    <>
      <PageHeader
        title="受付"
        description={
          <>
          受付手順<br />
          1.イベントの選択<br />
          2.読み取り開始ボタンをタップ<br />
          3.カメラの許可を求められた場合許可をする<br />
          4.お客様が持参した参加証のQRコードをカメラで読み取る<br />
          5.来場日が予定通りであれば自動で受付が行われます。異なる場合は状況を確認し、受付ボタンを押してください。<br />
          <br />
          ※処理に少しお時間かかる場合がございますので5~10秒ほどお待ちください
          </>
        }
      />

      <EventSelectorBar />

      <QrScannerPanel onDetected={handleDetected} parseError={parseError} processing={processing}/>
      
      <VisitorLookupSection
        encodedSynergyId={encodedSynergyId}
        eventDate={eventDate}
        eventTableKey={eventTableKey}
        qrEventKey={qrEventKey}
        onCheckinLoadingChange={setProcessing}
      />
    </>
  );
};
``